module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"平均商品単価"}}')
  delete Component.options._Ctor
}
